import types from 'actions/types'
import { createPivotTableReducer } from 'reducers/pivotTable'
import { combineReducers } from 'redux'
import {get} from 'lodash'
import {InvoiceStatus} from 'helpers/invoices'
import {getPivotTableTotalReducer} from "helpers/pivotTable"

export const status = (state = InvoiceStatus.AWAITING_POSTING.id, action) => {
  switch (action.type) {
    case types.INVOICING_VIEW_INVOICES_UPDATE_FILTERS:
      return get(action, 'filters.status', state)
    default: return state
  }
}

export const companyId = (state = null, action) => {
  switch (action.type) {
    case types.INVOICING_VIEW_INVOICES_UPDATE_FILTERS: return (action.filters.hasOwnProperty('companyId')) ? action.filters.companyId : state
    case types.CONTACTS_RECENTS_REMOVE: return state && state === action.companyId ? null : state
    case types.CONTACTS_RECENTS_CLEAR: return null  // not necessarily correct, but best guess
    default: return state
  }
}

export const timeKey = (state = null, action) => {
  switch (action.type) {
    case types.INVOICING_VIEW_INVOICES_UPDATE_FILTERS:
      return get(action, 'filters.timeKey', state)
    default: return state
  }
}

export const targetStart = (state = null, action) => {
  switch (action.type) {
    case types.INVOICING_VIEW_INVOICES_UPDATE_FILTERS:
      return get(action, 'filters.targetStart', state)
    default:
      return state
  }
}

export const targetEnd = (state = null, action) => {
  switch (action.type) {
    case types.INVOICING_VIEW_INVOICES_UPDATE_FILTERS:
      return get(action, 'filters.targetEnd', state)
    default:
      return state
  }
}

export const estimatorId = (state = null, action) => {
  switch (action.type) {
    case types.INVOICING_VIEW_INVOICES_UPDATE_FILTERS:
      return get(action, 'filters.estimatorId', state)
    default: return state
  }
}

export const orderTypeId = (state = null, action) => {
  switch (action.type) {
    case types.INVOICING_VIEW_INVOICES_UPDATE_FILTERS:
      return get(action, 'filters.orderTypeId', state)
    default: return state
  }
}

const total = (state = null, action) => {
  return getPivotTableTotalReducer(state, action, invoicingContextInvoicesPivotTableKey)
}

export const batchInvoices = (state = null, action) => {
  switch (action.type) {
    case types.INVOICING_LOAD_BATCH_INVOICES_SUCCESS:
      return action.data

    case types.INVOICING_LOAD_BATCH_INVOICES_ATTEMPT:
    case types.INVOICING_LOAD_BATCH_INVOICES_FAILURE:
      return null

    default:
      return state
  }
}

export const invoicingContextInvoicesPivotTableKey = 'invoicingContext.invoices.pivotTable'

export default combineReducers({
  pivotTable: createPivotTableReducer({key: invoicingContextInvoicesPivotTableKey,defaultSortColumn: 'desc'}),
  companyId,
  batchInvoices,
  status,
  timeKey,
  targetStart,
  targetEnd,
  estimatorId,
  orderTypeId,
  total,
})
